import { createContext } from "react";

export interface Empresa {
  id: number;
  //nome: string;
  slug: string;
  titulo: string;
  descricao: string;
  logo?: string;
  cidade: string; uf: string;
  aberto: boolean;
  horarioFechamento: string;
  disponivelEntregas: boolean;
  programaFidelidade: boolean;
  integracaoIfood: boolean;
}

interface EmpresaContextType {
  empresa: Empresa | null;
  loading: boolean;
}

export const EmpresaContext = createContext<EmpresaContextType>({
  empresa: null,
  loading: true,
});